import { useEffect, useState } from "react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Cell } from 'recharts';

export default function MissedCalls() {
    const [missedCalls, setMissedCalls] = useState([]);

    useEffect(() => {
        const loadMissed = () => {
            fetch("https://centrex.amservices.eu/api/dashboard/missed.php")
                .then(r => r.json())
                .then(data => {
                    // On vérifie si on a bien le tableau 'missed_today'
                    if (!data.missed_today) return;

                    console.log("Appels manqués reçus :", data.missed_today);

                    const seen = new Set();
                    const unique = [];

                    for (const call of data.missed_today) {
                        // On sécurise la date
                        const timeKey = call.time ? new Date(call.time).toISOString().slice(0, 19) : 'no-date';

                        // CORRECTION 1 : On utilise le 'from' (client) pour identifier l'appel, pas le 'to'
                        const callerNumber = call.from || "Inconnu";
                        const key = `${callerNumber}_${timeKey}`;

                        if (!seen.has(key)) {
                            seen.add(key);
                            unique.push(call);
                        }
                    }

                    // Tri du plus récent au plus ancien
                    unique.sort((a, b) => new Date(b.time) - new Date(a.time));
                    setMissedCalls(unique);
                })
                .catch(err => {
                    console.error("Erreur API Missed:", err);
                    setMissedCalls([]);
                });
        };

        loadMissed();
        const interval = setInterval(loadMissed, 5000);
        return () => clearInterval(interval);
    }, []);

    // 📊 Préparation des données par heure
    const chartData = (() => {
        const counts = {};
        // Heures de bureau (08h à 19h)
        for (let i = 8; i <= 19; i++) {
            counts[`${i}h`] = 0;
        }
        console.log(missedCalls, 'appel manqué');

        missedCalls.forEach(call => {
            if (call.time) {
                const date = new Date(call.time);
                const hourKey = `${date.getHours()}h`;
                if (counts[hourKey] !== undefined) {
                    counts[hourKey]++;
                } else {
                    counts[hourKey] = (counts[hourKey] || 0) + 1;
                }
            }
        });

        return Object.entries(counts).map(([hour, count]) => ({ hour, count }));
    })();

    return (
        <div className="missed-calls-container" style={{ display: 'flex', gap: '20px', marginTop: '20px', flexWrap: 'wrap' }}>

            {/* 📊 GRAPHIQUE HISTOGRAMME */}
            <div style={{ flex: '2', minWidth: '300px', background: '#fff', borderRadius: '8px', padding: '15px', boxShadow: '0 2px 5px rgba(0,0,0,0.1)' }}>
                <h3 style={{ margin: '0 0 15px 0', fontSize: '1rem', color: '#d32f2f' }}>📉 Répartition par heure</h3>
                <div style={{ height: '250px' }}>
                    <ResponsiveContainer width="100%" height="100%">
                        <BarChart data={chartData} barSize={30}>
                            <CartesianGrid strokeDasharray="3 3" vertical={false} />
                            <XAxis dataKey="hour" tick={{ fontSize: 12 }} />
                            <YAxis allowDecimals={false} />
                            <Tooltip
                                cursor={{ fill: 'transparent' }}
                                contentStyle={{ borderRadius: '8px', border: 'none', boxShadow: '0 2px 8px rgba(0,0,0,0.2)' }}
                            />
                            <Bar dataKey="count" fill="#d32f2f" radius={[4, 4, 0, 0]}>
                                {chartData.map((entry, index) => (
                                    <Cell key={`cell-${index}`} fill={entry.count > 0 ? "#d32f2f" : "#f0f0f0"} />
                                ))}
                            </Bar>
                        </BarChart>
                    </ResponsiveContainer>
                </div>
            </div>

            {/* 📋 LISTE DROITE */}
            <div style={{ flex: '1', minWidth: '250px', background: '#fff', borderRadius: '8px', padding: '15px', boxShadow: '0 2px 5px rgba(0,0,0,0.1)', maxHeight: '300px', overflowY: 'auto' }}>
                <h3 style={{ margin: '0 0 10px 0', fontSize: '1rem', color: '#333' }}>📜 Détail appels</h3>
                {missedCalls.length === 0 ? (
                    <p style={{ color: '#888', fontStyle: 'italic' }}>Aucun appel manqué</p>
                ) : (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                        {missedCalls.map((call, index) => {
                            const uniqueKey = `${call.from}_${call.time}_${index}`;

                            return (
                                <div key={uniqueKey} style={{
                                    padding: '10px',
                                    borderLeft: '4px solid #d32f2f',
                                    background: '#fff0f0',
                                    fontSize: '0.9rem',
                                    borderRadius: '0 4px 4px 0'
                                }}>
                                    {/* 👇 CORRECTION ICI : On affiche call.from au lieu de call.to */}
                                    <div style={{ fontWeight: 'bold', color: '#b71c1c' }}>
                                        📞 {call.from}
                                    </div>
                                    <div style={{ fontSize: '0.8em', color: '#666' }}>
                                        {call.time ? new Date(call.time).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : '--:--'}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                )}
            </div>
        </div>
    );
}